export const SYNC_TYPE = {
  WWG_WAGE: 'WWG_WAGE',
  EMPLOYEE: 'EMPLOYEE',
}